module.exports = __webpack_public_path__ + "img/boosQiu.1f525e96.png";